const createQueryParams = (queryParams: { [index: string]: string | boolean | number }) => {
  const query = Object.entries(queryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
  return query ? `?${query}` : ''
}

export default createQueryParams
